/** Small pure pieces of the Decide page: the card step's target, "use the same reason", a desk's lock holders and the guided desk note. */
import type { ContentCatalog, DraftView, TeamState } from "@bsim/contracts";
import type { DecisionFamily } from "@bsim/domain";
import { roleLabel } from "../shell/TopBar";
import { deskLabel } from "./labels";

/** What a card step takes the player to: the card's reason box, else its first answer, else the card itself, so the button always lands on the card. */
export function eventTarget(injectionId: string): HTMLElement | null {
  const card = document.querySelector<HTMLElement>(`[data-testid='event.card.${injectionId}']`);
  if (card === null) return null;
  const target = card.querySelector<HTMLElement>("textarea") ?? card.querySelector<HTMLElement>("[role='radio']");
  if (target !== null) return target;
  card.tabIndex = -1;
  return card;
}

/** Another changed desk's saved reason, for the "use the same reason" offer on a desk that has none yet; undefined when no other desk has one. */
export function sameReasonAs(catalog: ContentCatalog, draft: DraftView, family: DecisionFamily): { readonly desk: string; readonly text: string } | undefined {
  const other = draft.changedFamilies.find((f) => f !== family && (draft.rationales[f]?.text ?? "").trim() !== "");
  return other === undefined ? undefined : { desk: deskLabel(catalog, other), text: draft.rationales[other]?.text ?? "" };
}

export const holdersOf = (team: TeamState, userId: string): Partial<Record<DecisionFamily, string>> =>
  Object.fromEntries(Object.entries(team.draft?.familyLocks ?? {}).flatMap(([family, lock]) =>
    lock === undefined || lock.userId === userId ? [] : [[family, team.members.find((m) => m.userId === lock.userId)?.displayName ?? roleLabel(lock.role)]]));

/** Said once, in each desk's header, so the rows below need not repeat it. */
